<select class="form-control" [id]="inputId" [(ngModel)]="selectedValue"
    [ngModelOptions]="{standalone: true}" [disabled]="disabled"
    (ngModelChange)="onSelectChange($event)" (blur)="markAsTouched()">
    <option value="" disabled hidden>Sélectionnez</option>
    <option *ngFor="let option of options" [value]="option.value">
        {{ option.value }}<ng-container *ngIf="option.helper_text"> — {{ option.helper_text }}</ng-container>
    </option>
</select>

<input *ngIf="isFreeText" type="text" class="form-control mt-2" placeholder="Précisez"
    [ngModel]="freeText" [ngModelOptions]="{standalone: true}" [disabled]="disabled"
    (ngModelChange)="onFreeTextChange($event)" />
